import { AgentToolResult } from './tool-result.js';
import { Type } from '@sinclair/typebox';
import { SafeNonNegativeInteger } from './cursor.js';
import { AgentInteractionRequest, AgentInteractionResponse, AgentToolDetail } from './interactions.js';
import { ResourceBinding } from './resources.js';
const NonEmptyString = Type.String({ minLength: 1 });
const Strict = (properties) => Type.Object(properties, { additionalProperties: false });
export const AgentTaskItem = Strict({
    text: Type.String(),
    completed: Type.Boolean(),
    id: Type.Optional(NonEmptyString),
    status: Type.Optional(Type.Union([
        Type.Literal('pending'), Type.Literal('in_progress'), Type.Literal('completed'),
    ])),
    activeForm: Type.Optional(Type.String()),
});
const ToolCallBase = {
    type: Type.Literal('tool_call'),
    callId: NonEmptyString,
    name: NonEmptyString,
    detail: AgentToolDetail,
    result: Type.Optional(AgentToolResult),
};
export const AgentToolCallTimelineItem = Type.Union([
    Strict({ ...ToolCallBase, status: Type.Literal('running'), error: Type.Null() }),
    Strict({ ...ToolCallBase, status: Type.Literal('completed'), error: Type.Null() }),
    Strict({ ...ToolCallBase, status: Type.Literal('failed'), error: NonEmptyString }),
    Strict({ ...ToolCallBase, status: Type.Literal('canceled'), error: Type.Null() }),
]);
export const UserMessageWithoutOrigin = Strict({
    type: Type.Literal('user_message'),
    text: Type.String(),
    messageId: Type.Optional(NonEmptyString),
    clientMessageId: Type.Optional(NonEmptyString),
});
export const AgentUserMessageOrigin = Strict({ kind: Type.Union([
        Type.Literal('borgee'), Type.Literal('native'), Type.Literal('agent'), Type.Literal('unknown'),
    ]) });
const UserMessage = Strict({ ...UserMessageWithoutOrigin.properties, origin: Type.Optional(AgentUserMessageOrigin) });
export const timelineItemsWithUser = (user) => Type.Union([
    user,
    Strict({
        type: Type.Literal('assistant_message'),
        text: Type.String(),
        messageId: Type.Optional(NonEmptyString),
    }),
    Strict({ type: Type.Literal('reasoning'), text: Type.String() }),
    AgentToolCallTimelineItem,
    Strict({ type: Type.Literal('todo'), items: Type.Array(AgentTaskItem) }),
    Strict({ type: Type.Literal('interaction'), request: AgentInteractionRequest, response: AgentInteractionResponse }),
    Strict({ type: Type.Literal('error'), message: Type.String() }),
    Strict({
        type: Type.Literal('compaction'),
        status: Type.Union([Type.Literal('loading'), Type.Literal('completed')]),
        trigger: Type.Optional(Type.Union([Type.Literal('auto'), Type.Literal('manual')])),
        preTokens: Type.Optional(SafeNonNegativeInteger),
    }),
]);
export const AgentTimelineItem = timelineItemsWithUser(UserMessage);
/** Settled disjoint token deltas; inputTokens excludes cache reads and writes. */
export const AgentUsageAccounting = Strict({
    measurementId: NonEmptyString,
    scope: Type.Union([Type.Literal('turn'), Type.Literal('llm_call')]),
    provider: NonEmptyString,
    model: NonEmptyString,
    inputTokens: SafeNonNegativeInteger,
    outputTokens: SafeNonNegativeInteger,
    cacheReadTokens: SafeNonNegativeInteger,
    cacheWriteTokens: SafeNonNegativeInteger,
});
export const AgentUsage = Strict({
    accounting: Type.Optional(Type.Array(AgentUsageAccounting)),
    inputTokens: Type.Optional(SafeNonNegativeInteger),
    cachedInputTokens: Type.Optional(SafeNonNegativeInteger),
    outputTokens: Type.Optional(SafeNonNegativeInteger),
    totalCostUsd: Type.Optional(Type.Number({ minimum: 0 })),
    contextWindowMaxTokens: Type.Optional(SafeNonNegativeInteger),
    contextWindowUsedTokens: Type.Optional(SafeNonNegativeInteger),
});
export const TimelineSeqRange = Strict({
    startSeq: SafeNonNegativeInteger,
    endSeq: SafeNonNegativeInteger,
});
export const TimelineCollapse = Type.Union([
    Type.Literal('assistant_merge'),
    Type.Literal('reasoning_merge'),
    Type.Literal('tool_lifecycle'),
]);
export const ProjectedTimelineEntry = Strict({
    providerId: NonEmptyString,
    item: AgentTimelineItem,
    turnId: Type.Optional(NonEmptyString),
    timestamp: NonEmptyString,
    seqStart: SafeNonNegativeInteger,
    seqEnd: SafeNonNegativeInteger,
    sourceSeqRanges: Type.Array(TimelineSeqRange),
    collapsed: Type.Array(TimelineCollapse),
    resources: Type.Array(ResourceBinding),
});
//# sourceMappingURL=timeline.js.map